import { Button } from '@ria-client/tw-shadcn/components/button';
import type { NodeProps } from '../types';
import { ContentLink } from './lib/content-link';

export type SCButtonProps = NodeProps<{
  block?: boolean;
  buttonAnnotation?: string;
  children: string;
  href: string;
  primary?: boolean;
  target?: string;
}>;

export function SCButton({ props }: SCButtonProps) {
  return (
    <div className={`flex flex-col items-center gap-0.5${props.block ? ' w-full' : ''}`}>
      <Button
        asChild
        className={props.block ? 'w-full' : undefined}
        variant={props.primary ? 'default' : 'outline'}
      >
        <ContentLink href={props.href} target={props.target}>
          {props.children}
        </ContentLink>
      </Button>
      {props.buttonAnnotation && (
        <span className="text-center text-sm text-muted-foreground">{props.buttonAnnotation}</span>
      )}
    </div>
  );
}
